const RELOAD_FLAG = "chunkReloadAt";
const RELOAD_INTERVAL_MS = 10000;

const wrappedFactories = new WeakMap();

export function isChunkLoadError(error) {
  if (!error) {
    return false;
  }

  return error.name === "ChunkLoadError" || /Loading (CSS )?chunk [\w-]+ failed/.test(error.message);
}

/**
 * Recarrega a página em `url` buscando o index.html no servidor.
 * Não recarrega de novo dentro de RELOAD_INTERVAL_MS, para não entrar em loop se o arquivo não existir.
 */
export function reloadOnce(url = window.location.href) {
  try {
    const lastReload = Number(sessionStorage.getItem(RELOAD_FLAG));

    if (lastReload && Date.now() - lastReload < RELOAD_INTERVAL_MS) {
      return false;
    }

    sessionStorage.setItem(RELOAD_FLAG, String(Date.now()));
  } catch (e) {
    // sessionStorage indisponível: recarrega sem proteção contra loop
  }

  if (url !== window.location.href) {
    window.history.replaceState(null, "", url);
  }

  window.location.reload();

  return true;
}

/**
 * Envolve a factory de um componente assíncrono para recarregar a página quando o chunk falhar.
 * Devolve sempre o mesmo wrapper para a mesma factory, preservando o cache de resolução do Vue.
 */
export function reloadOnChunkError(factory) {
  if (!wrappedFactories.has(factory)) {
    wrappedFactories.set(factory, () =>
      factory().catch(error => {
        if (isChunkLoadError(error)) {
          reloadOnce();
        }

        throw error;
      })
    );
  }

  return wrappedFactories.get(factory);
}
